import { useMemo } from "react";
import { createPortal } from "react-dom";

interface JsonLdProps {
  data: Record<string, any> | Record<string, any>[];
}

/**
 * Renders a JSON-LD script tag in <head>.
 * Accepts a single schema object or an array (will wrap in @graph).
 */
export function JsonLd({ data }: JsonLdProps) {
  const json = useMemo(() => {
    const payload = Array.isArray(data)
      ? { "@context": "https://schema.org", "@graph": data }
      : { "@context": "https://schema.org", ...data };
    return JSON.stringify(payload);
  }, [data]);

  return createPortal(
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />,
    document.head
  );
}
